<template>
    <Scroll :height="height">
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <div style="position:relative; margin-top:15px;">
            <Form ref="formStep1" :label-width="120" :model="formItem">
                <FormItem label="地址：">
                    <Cascader v-model="addressList" :data="addressData" filterable transfer
                        placeholder="请选择地址" @on-change="choiceAll"></Cascader>
                    <p v-show="acustomerIdcard" style="line-height: 32px; color: #19be6b;text-align: left;">
                        {{"当前地址已绑定 " + acustomerIdcard + "|" +acustomerName+",填写新用户将覆盖该信息"}}
                    </p>
                </FormItem>
                <FormItem label="设备编号：">
                    <Select v-model="meterId" filterable remote :remote-method="searchMeter" :loading="loadingSearch"
                        placeholder="请输入并选择设备编号">
                        <Option v-for="(option, index) in optionsSearchMeter" :value="option.meterId" :key="index">{{option.meterId}}</Option>
                    </Select>
                </FormItem>
                <!--FormItem label>
                    <Row>
                        <Col span=12>
                        <Button style="float: left" onclick="$('#code').click();">扫描条形码</Button>
                        </Col>
                        <Col span=12>
                        <p style="line-height: 16px">{{barCode}}</p>
                        </Col>
                    </Row>
                    <input id="code" class="pad10 b-f" style="display: none;" type="file" 
                        capture="camcorder" accept="image/*" @change="onClickInputFile" />
                </FormItem-->
                <FormItem label>
                    <Row>
                        <Col span=12>
                        <Button style="float: left" @click="wechatScan">扫描条形码</Button>
                        </Col>
                        <Col span=12>
                        <p style="line-height: 16px">{{barCode}}</p>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label="用户证件号：">
                    <Select v-model="customerId" filterable remote :remote-method="searchCustomer" :loading="loadingSearch"
                        placeholder="请输入证件号并选择用户">
                        <Option v-for="(option, index) in optionsSearchCustomer" :value="option.customerId" :key="index">{{option.customerIdcard + " " + option.customerName}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </div>
    </Scroll>
</template>
<script>
    import Quagga from 'quagga';
    export default {
        props: {
            onOk: {
                type: Function
            }
        },
        created() {},
        mounted() {
            this.getAddress();
        },
        data() {
            return {
                isSpinShow: false,
                height: document.body.clientHeight,
                meterId: "",
                loadingSearch: false,
                optionsSearchMeter: [],
                formItem: {},
                addressData: [],
                addressDataSelect: "",
                addressList: [],
                customerId: "",
                addressId: 0,
                optionsSearchCustomer: [],
                barCode: "",
                acustomerIdcard: "",
                acustomerName: ""
            };
        },
        methods: {
            bindSGInfo() {
                if (this.meterId == "" || this.addressId <= 0) {
                    this.$Notice.info({
                        title: "提示",
                        desc: "请选择需绑定数据"
                    });
                    return;
                }

                this.isSpinShow = true;

                var that = this;
                $.ajax({
                    url: "/api/bindSGInfo",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        lowestAddressId: that.addressId,
                        meterId: that.meterId,
                        customerId: that.customerId
                    }),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }

                        that.$Notice.success({
                            title: "提示",
                            desc: "信息绑定成功"
                        });

                        that.addressId = 0;
                        that.meterId = "";
                        that.customerId = "";
                        that.addressList = [];
                        that.optionsSearchMeter = [];
                        console.log(that);
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(XMLHttpRequest, textStatus) {
                        that.isSpinShow = false;
                    }
                });
            },
            searchCustomer(query) {
                if (query !== '' && query.indexOf(' ') === -1) {
                    //查询表具信息
                    var that = this;
                    clearTimeout(that.timer)
                    that.timer = setTimeout(function() {
                        if (that.isSpinShow == false) {
                            that.isSpinShow = true;
                        }
                        if (that.isSpinShow == false) {
                            that.loadingSearch = true;
                        }
                        $.ajax({
                            url: "/api/getAllCustomerInfoWithoutPage",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify({
                                idCard: query
                            }),
                            dataType: "json",
                            success: function(receiveData) {
                                if (receiveData.errorCode == 0) {
                                    that.optionsSearchCustomer = receiveData.body;
                                    console.log(receiveData);
                                } else {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: receiveData.errorInfo
                                    });
                                }
                                that.isSpinShow = false;
                            },
                            error: function(textStatus) {
                                that.isSpinShow = false;
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function() {
                                that.loadingSearch = false;
                            }
                        });
                    }, 1000)
                }
            },
            onClickInputFile(param) {
                let that = this;
                that.isSpinShow = true;
                if (param.target.files) {
                    // 压缩文件
                    lrz(param.target.files[0])
                        .then(function(rst) {
                            console.log(rst);
                            //that.imgBarCode = rst.base64;
                            that.scanBarCode(rst.base64);
                        })
                        .catch(function(error) {
                            //失败时执行
                        })
                        .always(function() {
                            //不管成功或失败，都会执行
                        });
                }
            },
            getAddress() {
                var that = this;
                $.ajax({
                    url: "/api/getAddressTree",
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }

                        that.addressData = data.body[0].children;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            searchMeter(meterId) {
                //查询表具信息
                var that = this;
                clearTimeout(that.timer)
                that.timer = setTimeout(function() {
                    if (that.isSpinShow == false) {
                        that.isSpinShow = true;
                    }
                    $.ajax({
                        url: "/api/getMeterInfoWithoutPage",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            meterId: meterId
                        }),
                        dataType: "json",
                        success: function(receiveData) {
                            if (receiveData.errorCode == 0) {
                                that.optionsSearchMeter = receiveData.body;
                                console.log(receiveData);
                            } else {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: receiveData.errorInfo
                                });
                            }
                            that.isSpinShow = false;
                        },
                        error: function(textStatus) {
                            that.isSpinShow = false;
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        }
                    });
                }, 1000)
            },
            scanBarCode(base64) {
                let that = this;
                console.log(base64);
                Quagga.decodeSingle({
                        //解码方式，与条形码的编码方式有关
                        decoder: {
                            readers: ["code_128_reader"]
                        },
                        numOfWorkers: 0,
                        locate: true, // try to locate the barcode in the image
                        src: base64 // or 'data:image/jpg;base64,' + data
                    },
                    function(result) {
                        that.isSpinShow = false;
                        console.log(result);
                        if (result) {
                            if (result.codeResult) {
                                //that.meterId = ;
                                that.barCode = result.codeResult.code;
                                that.meterId = result.codeResult.code;
                                // $.ajax({
                                //     url: "/api/getProduceMeterInfoByBatch?barCode=" + that.barCode,
                                //     contentType: "application/json",
                                //     type: "get",
                                //     async: false,
                                //     dataType: "json",
                                //     success: function(receiveData) {
                                //         if (receiveData.meterList.length == 0) {
                                //             alert("未生产该条码！");
                                //         } else {
                                //             that.meterId = receiveData.meterList[0].boardId;
                                //             that.barCode = result.codeResult.code + "\n" + receiveData.meterList[
                                //                 0].boardId;
                                //         }
                                //     },
                                //     error: function(textStatus) {
                                //         that.$Notice.error({
                                //             title: "异常",
                                //             desc: "接口请求异常"
                                //         });
                                //     },
                                //     complete: function(XMLHttpRequest, textStatus) {
                                //         that.loading = false;
                                //     }
                                // });
                                // $("#result").val(result.codeResult.code);
                            } else {
                                alert("条码格式错误，请使用Code128条码！");
                                $("#result").val("");
                            }
                        } else {
                            alert("未扫码成功，请重新扫码!");
                            $("#result").val("");
                        }
                    }
                );
            },
            choiceAll(data) {
                this.addressId = data[data.length - 1];
                if (data.length == 7) {
                    var that = this;
                    that.isSpinShow = true;
                    $.ajax({
                        url: "/api/getAddressCustomer",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            addressLowestLevelAddressId: that.addressId
                        }),
                        dataType: "json",
                        success: function(data) {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }
                            that.acustomerIdcard = data.body.customerIdcard;
                            that.acustomerName = data.body.customerName;
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function() {
                            that.isSpinShow = false;
                        }
                    });
                }
            },
            wechatScan() {
                var that = this;
                that.isSpinShow = true;
                var thisUrl = encodeURIComponent(location.href);
                $.ajax({
                    url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.body == null) {
                            return;
                        }
                        wx.config({
                            debug: false, // 开启调试模式，关闭
                            appId: receiveData.body.appId, // 必填，公众号的唯一标识
                            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
                            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
                            signature: receiveData.body.signature, // 必填，签名
                            jsApiList: ["scanQRCode"] // 需要使用的jsapi列表
                        });
                        wx.ready(function() {
                            wx.checkJsApi({
                                jsApiList: ["scanQRCode"],
                                success: function(res) {
                                    wx.scanQRCode({
                                        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                                        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                                        success: function(res) {
                                            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                                            if (result.indexOf("CODE_128") != -1) {
                                                that.barCode = result.split(",")[1];
                                                that.meterId = result.split(",")[1];
                                            }else{
                                                that.$Notice.error({
                                                    title: "异常",
                                                    desc: "请使用code_128条码！"
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                        });
                        console.log(receiveData);
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(XMLHttpRequest, textStatus) {
                        that.isSpinShow = false;
                    }
                });
            }
        }
    };
</script>
